import { FC } from 'react';

// TODO: product data interface
interface Props {
    product: any;
}

export const SearchResultCard: FC<Props> = ({ product }) => {
    return (
        <>
            <li className="grid__item scroll-trigger animate--slide-in">
                <div className="card-wrapper product-card-wrapper underline-links-hover br-cardProduct__container br-product-card">
                    <a
                        href={`/products/${product.node.handle}`}
                        className="card-wrapper product-card-wrapper underline-links-hover br-cardProduct__content"
                    >
                        <img
                            className="full-unstyled-link"
                            src={product.node.featuredImage.transformedSrc}
                            alt={product.node.title}
                        />
                        <div className="card__content br-cardProduct__content">
                            <div className="card__information">
                                <h3 className="card__heading h5">
                                    <a href={`/products/${product.node.handle}`} className="full-unstyled-link">
                                        {product.node.title}
                                    </a>
                                </h3>
                            </div>
                        </div>
                    </a>
                </div>
            </li>
        </>
    );
};
